import { create } from "zustand";
import {
  Category,
  Degree,
  Industry,
  Language,
  Level,
  Province,
} from "@/modules/types/metadata/metadata";
import { persist } from "zustand/middleware";

interface provinceStore {
  provinces: Province[];
  setProvinces(provinces: Province[]): void;
}

export const useProvinceStore = create<provinceStore>()(
  persist(
    (set) => ({
      provinces: [],
      setProvinces: (provinces: Province[]) => set({ provinces }),
    }),
    {
      name: "tgw-province-store",
    },
  ),
);

interface metadataStore {
  levels: Level[];
  degrees: Degree[];
  languages: Language[];
  categories: Category[];
  industries: Industry[];
  setLevels: (levels: Level[]) => void;
  setDegrees: (degrees: Degree[]) => void;
  setLanguages: (languages: Language[]) => void;
  setCategories: (categories: Category[]) => void;
  setIndustries: (industries: Industry[]) => void;
}

export const useMetadataStore = create<metadataStore>()(
  persist(
    (set) => ({
      levels: [],
      degrees: [],
      languages: [],
      categories: [],
      industries: [],
      setLevels: (levels: Level[]) => set({ levels }),
      setDegrees: (degrees: Degree[]) => set({ degrees }),
      setLanguages: (languages: Language[]) => set({ languages }),
      setCategories: (categories: Category[]) => set({ categories }),
      setIndustries: (industries: Industry[]) => set({ industries }),
    }),
    {
      name: "tgw-metadata-store",
    },
  ),
);
